class MinerwaTopSellers extends HTMLElement {
  connectedCallback() {
    this.results = this.querySelector('[data-sellers-results]');
    this.source = this.dataset.source;
    this.sectionId = this.dataset.section;
    if (!this.results || !this.source) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '400px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    try {
      const response = await fetch(`${this.source}?section_id=${this.sectionId}`);
      if (!response.ok) throw new Error(`Top sellers failed: ${response.status}`);

      const markup = await response.text();
      const payload = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-top-sellers-payload]');

      if (payload && payload.querySelector('.minerwa-sellers__card')) {
        this.results.replaceChildren(...payload.childNodes);
        this.dataset.loaded = 'true';
      } else {
        this.remove();
      }
    } catch (error) {
      this.remove();
    }
  }
}

if (!customElements.get('minerwa-top-sellers')) {
  customElements.define('minerwa-top-sellers', MinerwaTopSellers);
}
